import axios from "axios";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Footer from "../Footer/Footer";
import classes from "../Login/Login.module.css";
import VisitorClasses from "./VisitorPass.module.css";
import "../../../assets/css/visitor-css/master.css";
import "./print-styles.css";
import moment from "moment";
import { QRCodeSVG } from 'qrcode.react';

const base_url = process.env.REACT_APP_BASE_URL;
const SpecialVisitorPassByAdmin = () => {
  const navigate = useNavigate();
  const [showQr, setShowQr] = useState(false);
  const location = useLocation();
  let Id;
  // let footerText1 = "";
  // let footerText2 = "";
  if (location.pathname.includes("special-pass")) {
    Id = location.pathname.substring(14, location.pathname.length);
  } else {
    Id = location.pathname.substring(6, location.pathname.length);
  }

  const [didPass, setDigiPass] = useState({});
  const [footerText1, setfooterText1] = useState("");
  const [footerText2, setfooterText2] = useState("");
  const [domLoaded, setDomLoaded] = useState(false);
  const [qrValue, setQrValue] = useState("");
  const [logo, setLogo] = useState("");
  const [isExpired, setIsExpired] = useState(false);
  const [printMode, setPrintMode] = useState(false);
  const path = location.pathname;
  let showApprove = !path.includes("digipass");
  
  // Check if we're in print mode
  // useEffect(() => {
  //   const searchParams = new URLSearchParams(window.location.search);
  //   const isPrintMode = searchParams.get('print') === 'true';
  //   setPrintMode(isPrintMode);
    
  //   if (isPrintMode) {
  //     // Add print styles
  //     document.body.classList.add('print-mode');
      
  //     // After a short delay, trigger the print dialog
  //     const timer = setTimeout(() => {
  //       window.print();
  //       // Close the window after printing (or if user cancels)
  //       window.onafterprint = () => window.close();
  //     }, 1000);
      
  //     return () => {
  //       clearTimeout(timer);
  //       document.body.classList.remove('print-mode');
  //     };
  //   }
  // }, []);

  const [isDevToolsOpened, setIsDevToolsOpened] = useState(false);
  /*
  useEffect(() => {
    const handleResize = () => {
      if (window.outerHeight - window.innerHeight > 100) {
        setIsDevToolsOpened(true);
        alert("Dev tool opened");
      } else {
        setIsDevToolsOpened(false);
      }
    };

    window.addEventListener("resize", handleResize);

    // Check if dev tools are already open after the initial render
    if (window.outerHeight - window.innerHeight > 100) {
      setIsDevToolsOpened(true);
      console.log("Dev tool opened");
      alert("Dev tool opened");
    }

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  */

  

  useEffect(() => {
    axios.get(`${base_url}/visitor/get-special-visitor/${Id}`).then((res) => {
      const visitorData = res.data.data;
      setDigiPass(visitorData);
      console.log("Specialpass Data", visitorData);
      
      // Check if pass is expired
      if (visitorData.visitingDate) {
        const endDate = new Date(visitorData.visitingDate);
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Reset time part for accurate date comparison
        const isExpired = endDate < today;
        setIsExpired(isExpired);
        
        /* if (isExpired) {
          navigate('/expired-pass');  
          return;
        } */
      } 
      // Generate QR code data with pass ID and validity info
      if (visitorData._id) {
        // Create data object with ID and validity dates
        const qrData = JSON.stringify({
          id: visitorData._id,
          validFrom: visitorData.validityStartDate,
          validTo: visitorData.validityEndDate,
          // Add other relevant data that might be needed for validation
          name: visitorData.name,
          passType: visitorData.passType
        });

        console.log('QR Data:', qrData);
        setQrValue(window.location.href);
        
        if (isExpired) {
          navigate('/expired-pass');
          return;
        }
      }
      // Generate QR code data with pass ID and validity info
      if (visitorData._id) {
        // Create data object with ID and validity dates
        const qrData = JSON.stringify({
          id: visitorData._id,
          validFrom: visitorData.validityStartDate,
          validTo: visitorData.validityEndDate,
          // Add other relevant data that might be needed for validation
          name: visitorData.name,
          passType: visitorData.passType
        });

        console.log('QR Data:', qrData);
        setQrValue(window.location.href);
      }
      return axios(
        `${base_url}/visitor/company/details/${res.data.data.companyId}`
      ).then((res) => {
        console.log("Company Data", res.data.data);
        setShowQr(res.data.data.boombarierQrCheck);
        if (res.data.data.footerStatus) {
          setfooterText1(res.data.data.footerTextOne);
          setfooterText2(res.data.data.footerTextTwo);
        }
        setLogo(res.data.data.logo);
        // setCompanyData(res.data.data);
        setDomLoaded(true);
      });
    });
  }, []);

  const handleApproveReject = (status) => {
    let reqObj = {
      method: "POST",
      url: `${base_url}/visitor/emp-decision`,
      headers: {
        "Content-Type": "application/json"
      },
      data: {
        visitorId: Id,
        status: status
      }
    };
    axios(reqObj)
      .then((res) => {
        navigate("/thank-you");
      })
      .catch((err) => {
        console.log(err);
      });
    // /visitor/end-meeting
    if (status == "rejected") {
      axios
        .put(`${base_url}/visitor/check-out/${Number(didPass.phone)}`, {
          checkedoutBy: `${didPass.empName}(Meeting person rejected.)`
        })
        .then((visitor) => { });
    }
  };

  const handlePrint = () => {
    // Add a class to the body when printing
    document.body.classList.add('printing');

    // Trigger print
    window.print();

    // Remove the class after a short delay
    setTimeout(() => {
      document.body.classList.remove('printing');
    }, 1000);
  };

  let showAccessories =
    didPass["isLaptop"] ||
    didPass["isMobile"] ||
    didPass["isHardDisk"] ||
    didPass["isCharger"] ||
    didPass["isOtherAccessory"];

  // let showValidId = didPass["docFront"] || didPass["docBack"];
  let showValidId = true;

  return (
    <>
      {domLoaded && (
        <div className="wrapper-box z1 special-bg-color">
          <div className="container z2" style={{ position: "relative" }}>
            {/* <div className="app-panel"> */}
            {/* <div
              className="bg-special z3"
              style={{
                background:
                  didPass.passType == "Vendor"
                    ? "linear-gradient(to top, #0f531d, #06521b)"
                    : "linear-gradient(to top, #edd52a, #c99a29)"
              }}
            ></div> */}
            <div
              className="bg-special z3"
              style={{
                background:
                  didPass.passType == "Vendor"
                    ? "linear-gradient(to top, #0f531d, #06521b)"
                    : "linear-gradient(to top, #edd52a, #c99a29)",
                borderRadius: "0",
                height: "100%"
              }}
            ></div>
            {/* <div className="bg-ellipes-left z3"></div> */}
            {/* <div className="bg-ellipes-right z3"></div> */}
            <div className="wrapper-mid z4" style={{ backgroundColor: "transparent",height:"100%" }}>
              <div className="logo-div" style={{ width: '80px', margin: '0 auto' }}>
                <img
                  src={require("../../../assets/img/visitor-images/images/logo.png")}
                  alt="DigiPass Logo"
                />
              </div>
              <div className="text-logo">
                <h1>DigiPass</h1>
                {/* <p>
                  Visitor Management <br></br>System
                </p> */}
                <p
                style={{
                  paddingTop: '10px',
                  paddingBottom: logo ? '10px' : '40px'
                }}>{didPass["passName"]}</p>
              </div>
              {logo && <div style={{
                width: '100px',
                margin: '0 auto 0 auto',
                position: 'relative',
                /* padding-top: 90px; */
                paddingTop: '10px',
                paddingBottom: '40px'
              }}>
                <img style={{
                  width: '80px',
                  margin: '0 auto',
                  display: 'block',
                  background:'#fff',
                  margin:'2px'
                }}
                  src={logo}
                />
              </div>}

              <div className="body-mid bg-white" style={{ marginTop: "2rem", position: 'relative' }}>
                {isExpired && (
                  <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1000,
                    borderRadius: '8px',
                    color: 'white',
                    fontSize: '24px',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    padding: '20px'
                  }}>
                    This pass has expired
                  </div>
                )}
                <div className="event-div even-div-special">
                  {didPass.selfie && (
                    <div className="pic-img">
                      <img src={didPass.selfie} />
                    </div>
                  )}
                  {!didPass.selfie && didPass.passType == "Vendor" && (
                    <div className="pic-img">
                      <img
                        src={require("../../../assets/img/visitor-images/profile_green.png")}
                        style={{ height: "80px" }}
                      />
                    </div>
                  )}
                  {!didPass.selfie && didPass.passType == "Delegate" && (
                    <div className="pic-img">
                      <img
                        src={require("../../../assets/img/visitor-images/profile_yellow.png")}
                        style={{ height: "80px" }}
                      />
                    </div>
                  )}
                  <div className="content">
                    <p>
                      <strong>{`${didPass.firstName} ${didPass.lastName}`}</strong>
                    </p>
                    <p>{didPass.phone}</p>
                    <p>{didPass.location}</p>
                  </div>
                </div>
                {showValidId && (
                  <div className="event-div even-div-special">
                    <div className="content">
                      <p className="govtid">Valid ID -</p>
                    </div>
                    {didPass.docFront && (
                      <div className="pic-img">
                        <img src={didPass.docFront} />
                        <p>Front</p>
                      </div>
                    )}
                    <div className="space-div"></div>
                    {didPass.docBack && (
                      <div className="pic-img">
                        <img src={didPass.docBack} />
                        <p>Back</p>
                      </div>
                    )}
                    {!didPass.docBack && !didPass.docFront && (
                      <div className="pic-img" style={{ marginLeft: "-44px" }}>
                        <img
                          src={
                            didPass.passType == "Vendor"
                              ? require("../../../assets/img/visitor-images/green_document.png")
                              : require("../../../assets/img/visitor-images/gold_document.png")
                          }
                        />
                        <p>Front</p>
                      </div>
                    )}
                  </div>
                )}
                <div className="event-div even-div-special pass-details">
                  {didPass.companyName && (
                    <p>
                      <label>Company Name</label>- {didPass.companyName}
                    </p>
                  )}
                  {didPass.passType == "Vendor" && didPass.vendorType && (
                    <p>
                      <label>Vendor Type</label>- {didPass.vendorType}
                    </p>
                  )}
                  {didPass.personToVisit && (
                    <p>
                      <label>Meeting Person</label>- {didPass.personToVisit}
                    </p>
                  )}
                  {didPass.passType == "Delegate" && (
                    <p>
                      <label>Pass Type</label>- Daily Pass
                    </p>
                  )}
                  {didPass.passType == "Vendor" && (
                    <p>
                      <label>Pass Type</label>- Vendor Pass
                    </p>
                  )}
                  {didPass.purposeOfVisit && (
                    <p>
                      <label>Purpose of visit</label>- {didPass.purposeOfVisit}
                    </p>
                  )}
                  {didPass.person_accompany && (
                    <p>
                      <label>Person Accompanying</label>-{" "}
                      {didPass.person_accompany}
                    </p>
                  )}
                  {didPass.passType == "Delegate" && (
                    <p>
                      <label>Valid Up to</label>-{" "}
                      {/* {didPass.visitingDate.substring(0, 10)} */}
                      {moment(didPass.visitingDate).format("YYYY-MM-DD")}
                    </p>
                  )}
                  {didPass.passType == "Vendor" && (
                    <p>
                      <label>Valid Up to</label>-{" "}
                      {/* {didPass.validityEndDate.substring(0, 10)} */}
                      {moment(didPass.validityEndDate).format("YYYY-MM-DD")}
                    </p>
                  )}
                  <p>
                    <label>Created Date</label>-{" "}
                    {moment(didPass.createdAt).format("MMM D, hh:mm A")}
                    {/* {moment(didPass.otpSent).format("MMM D, hh:mm A")} */}
                    {/* {moment(didPass.notifyUserSms).format("MMM D, hh:mm A")} */}
                    {/* {moment(didPass.createdAt).format("MMM D, hh:mm A")} */}
                  </p>
                </div>
                
               {showQr && <div style={{ 
                  textAlign: 'center', 
                  padding: '15px',
                  backgroundColor: '#fff',
                  margin: '15px 0',
                  borderRadius: '8px',
                  border: '1px solid #eee'
                }}>
                  <h3 style={{ margin: '0 0 10px 0', fontSize: '1rem' }}>Scan for Verification</h3>
                  {qrValue ? (
                    <div style={{
                      display: 'flex',
                      justifyContent: 'center',
                      padding: '10px',
                      backgroundColor: '#fff',
                      borderRadius: '4px',
                      margin: '0 auto',
                      maxWidth: '150px'
                    }}>
                      <QRCodeSVG
                        value={qrValue}
                        size={120}
                        level="H"
                        style={{
                          width: '100%',
                          height: 'auto',
                          maxWidth: '100%',
                          maxHeight: '100%'
                        }}
                      />
                    </div>
                  ) : (
                    <div style={{
                      width: '120px',
                      height: '120px',
                      margin: '0 auto',
                      backgroundColor: '#f5f5f5',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: '4px'
                    }}>
                      Loading QR...
                    </div>
                  )}
                  <p style={{ fontSize: '0.7rem', color: '#666', margin: '8px 0 0' }}>
                    Scan this QR code for verification
                  </p>
                </div>}
              </div>
              <footer
                className="visitor-pass-footer"
                style={{ backgroundColor: "transparent" }}
              >
                <p
                  style={{
                    color: didPass.passType == "Delegate" ? "#000" : "#fff"
                  }}
                >
                  {footerText1} <br></br> {footerText2}
                </p>
              </footer>
              {/* <Footer /> */}
            </div>
            {/* </div> */}
          </div>
        </div >
      )}
    </>
  );
};

export default SpecialVisitorPassByAdmin;
